const TYPES = [ 'hamburger', 'side', 'default' ] as const

export type TNavbarButton = typeof TYPES[number]

export interface IButtonProps {
  readonly text?: string
  readonly onClick: TVoidCallback
}

export interface INavbarButtonProps extends IButtonProps {
  readonly type?: TNavbarButton
}

export type TNavbarButtonData = IButtonProps[]

export interface INavbarButtonAttrs {
  readonly type?: TNavbarButton
}

export interface INavProps {
  /** Gombok adatai. */
  readonly buttonProps: TNavbarButtonData
  /** Egyéb children, pl. Logó, stb. */
  readonly children?: HTMLElement | DocumentFragment
}

export enum ENavbarEvent {
  HideSideMenu      = 'Navbar:HideSideMenu',
  ShowSideMenu      = 'Navbar:ShowSideMenu',
  SideButtonClicked = 'Navbar:SideButtonClicked'
}
